import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router'

import { TextField } from '@mui/material'
import { useStores, validateAndFormatNumber } from '@trivie/core'
import { Button, color, Text } from '@trivie/ui-mobile'
import { useTranslation } from 'react-i18next'

import { Divider } from '@trivie/ui-mobile/components/divider'
import { SocialLoginButtons } from '@trivie/ui-mobile/components/social-login-buttons'

export const MagicLinkScreen = () => {
  const { userStore } = useStores()
  const { setPhoneNumber, setFormattedPhoneNumber } = userStore
  const history = useHistory()
  const { control, watch, handleSubmit } = useForm()
  const { login } = watch()

  const { t } = useTranslation()
  const formPlaceholder = t('Onboarding.Login.yourEmailHerePlaceholder')

  const sendMagicLink = (data: any) => {
    const phone = validateAndFormatNumber(data.login)
    if (!data.login.includes('@') && phone) {
      setPhoneNumber(data.login)
      setFormattedPhoneNumber(phone)
      userStore.sendMagicLink(phone, 'com.trivie.engage.pmb', true).then((res: any) => {
        if (res.data.redirect_url) {
          window.location.replace(res.data.redirect_url)
        } else {
          history.push('/login/sms')
        }
      })
    } else if (data.login.includes('@')) {
      userStore.sendMagicLink(data.login, 'com.trivie.engage.pmb').then((res: any) => {
        userStore.setEmail(data.login)
        if (res.data.redirect_url) {
          window.location.replace(res.data.redirect_url)
        } else {
          history.push('/login/magic/sent')
        }
      })
    }
  }

  const [validated, setValidated] = useState(false)

  return (
    <div style={ROOT}>
      <div style={{ display: 'flex', gap: 12, flexDirection: 'column' }}>
        <Text align="center" tx="Onboarding.Login.logIn" variant="headline" />
        <Text
          align="center"
          variant="titleMedium"
          style={{ color: color.shade50 }}
          tx="Onboarding.Login.useMagicLink"
        />
      </div>
      <Controller
        control={control}
        defaultValue=""
        render={({ onChange, onBlur, value }) => (
          <TextField
            required
            onChange={(e) => {
              onChange(e.target.value)
              if (validateAndFormatNumber(e.target.value) || e.target.value.includes('@')) {
                setValidated(true)
              } else {
                setValidated(false)
              }
            }}
            onBlur={onBlur}
            value={value}
            style={{ width: 335, marginBottom: 51 }}
            size="small"
            helperText={login && !validated ? 'Enter a valid phone number or email address.' : ''}
            placeholder={formPlaceholder}
            error={login && !validated}
          />
        )}
        name="login"
        rules={{ required: true }}
      />
      <Button
        disabled={!validated}
        fullWidth
        tx="Common.continue"
        onPress={handleSubmit(sendMagicLink)}
        accessibilityRole="button"
        accessibilityLabel="Send Magic Link"
      />
      <Divider
        color={color.shade20}
        split={<Text variant="titleEmphasized" tx="Common.or" style={{ marginHorizontal: 10 }} />}
      />
      <SocialLoginButtons
        appleLogin={() =>
          window.location.replace(
            `${process.env.REACT_APP_SSO_APPLE_URL}?intent=signin&app_id=com.trivie.engage.pmb`,
          )
        }
        googleLogin={() =>
          window.location.replace(
            `${process.env.REACT_APP_SSO_GOOG_URL}?intent=signin&app_id=com.trivie.engage.pmb`,
          )
        }
      />
    </div>
  )
}

const ROOT: React.CSSProperties = {
  height: '100%',
  maxHeight: 575,
  width: 335,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  margin: 'auto',
}
